module.exports = __webpack_public_path__ + "static/media/RU.562474ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/RU.svg
// module id = 2250
// module chunks = 7